var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_394_6114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8367 10.6667L8.17002 8L5.50336 10.6667",
    stroke: "#0C8CE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17004 8V14",
    stroke: "#0C8CE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7634 12.2601C14.4136 11.9056 14.9272 11.3447 15.2233 10.6658C15.5193 9.98698 15.5808 9.22889 15.3982 8.5112C15.2155 7.7935 14.799 7.15708 14.2145 6.70237C13.6299 6.24766 12.9106 6.00056 12.17 6.00007H11.33C11.1282 5.21956 10.7521 4.49496 10.23 3.88073C9.70784 3.2665 9.05325 2.77864 8.31542 2.45381C7.57759 2.12898 6.77572 1.97564 5.9701 2.00533C5.16447 2.03501 4.37606 2.24694 3.66414 2.62518C2.95221 3.00342 2.33529 3.53814 1.85977 4.18913C1.38424 4.84011 1.06248 5.59043 0.918671 6.38367C0.774864 7.17691 0.812754 7.99242 1.02949 8.76891C1.24623 9.5454 1.63618 10.2626 2.17002 10.8667",
    stroke: "#0C8CE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8367 10.6667L8.17002 8L5.50336 10.6667",
    stroke: "#0C8CE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_6114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.170044)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.f3d1ca96f6ed3955da5f458823e7a0e8.svg";
export { ForwardRef as ReactComponent };